import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Tooltip from '@mui/material/Tooltip';
import { useColorScheme, useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { RouterLink } from 'src/routes/components';

import { CONFIG } from 'src/config-global';
import { varAlpha, bgGradient } from 'src/theme/styles';
import LoginPicture from 'src/assets/images/logo-image3.png';

// ----------------------------------------------------------------------

export function Section({
  sx,
  layoutQuery,
  imgUrl = LoginPicture,
  // imgUrl,
  ...other
}) {
  const theme = useTheme();
  const { mode } = useColorScheme();
  return (
    <Box
      sx={{
        zIndex: 100000,
        background: mode === 'light' ? 'white' : 'theme?.background',
        // px: 3,
        width: 1,
        maxWidth: 480,
        display: 'none',
        position: 'relative',
        [theme.breakpoints.up(layoutQuery)]: {
          gap: 8,
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          justifyContent: 'center',
        },
        ...sx,
      }}
      {...other}
    >
      <Box
        component="img"
        alt="Dashboard illustration"
        src={imgUrl || LoginPicture}
        sx={{
          height: 1,
          width: 1,
          aspectRatio: '4/4',
          objectFit: 'cover',
        }}
      />
    </Box>
  );
}
